import React, { useState, useEffect } from 'react'
import '../assets/styles/styles.css'
import install_prompt_icon from '../assets/images/install_prompt_icon.svg'
import { Button, Image } from 'react-bootstrap'
import { maxWidth } from '@mui/system';
function PwaModal(props) {

  const [installPrompt, setInstallPrompt] = useState(null);
  const [pwaIsInstalled, setPwaIsInstalled] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      console.log('beforeinstallprompt event triggered', e);
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Save the event so it can be triggered later.
      setInstallPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Cleanup the event listener when the component unmounts
    return () => {
        window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    // Hide the install button
    setInstallPrompt(null);
    // Show the install prompt
    if (installPrompt) {
        installPrompt.prompt();
        // Wait for the user to respond to the prompt
        const { outcome } = await installPrompt.userChoice;
        // Optionally, handle the outcome
      //  console.log(`User response to the install prompt: ${outcome}`);
      if( outcome === "accepted"){
        setPwaIsInstalled(true);
      }
    }
  };

  return (
    <div className="d-flex justify-content-center row">
      <div className="whole-container" style={{ width: "200%" }}>
        <img src={install_prompt_icon} style={{ width: "50%" }} alt="" />
        {!pwaIsInstalled ? (
          <>
            <h1 className="page-title light-blue-text">Add Bonez To Homescreen</h1>
            <h1 className="page-subtitle" style={{ color: "white" }}>Install is Required to play Bonez<br/>and provides an optimized game experience</h1>
            <br />
            <h1 className="page-subtitle mobile-title" style={{ color: "white" }}>
              {props.isSafari &&
                "In your Safari browser menu, tap the Share icon and choose Add to Home Screen in the options. Then open the app from your home screen."}
              {props.isChrome && installPrompt &&
                <Button onClick={handleInstallClick} size='lg' variant='success'>
                  Install Bonez
                </Button>}
              {props.isChrome && !installPrompt &&
                "In your Chrome browser menu tap the ⋮ icon at the top right corner and choose Install App in the options"}
              {props.isOtherAndroid &&
                "In your browser menu, tap the ⋮ icon and look for 'Add to Home Screen' or 'Install App' option. For best experience, we recommend using Chrome browser."}
            </h1>
          </>
        ) : (
          <>
            <h1 className="page-title light-blue-text" style={{ color: "white" }}>Installing...</h1>
            <p className="page-subtitle" style={{ color: "white" }}>Tap the <Image alt="" src="https://zoombies.world/images/bonez/bonez_logo_192x192.png" style={{maxWidth: '20px'}} /> Bonez launcher icon on your device in a moment </p>
          </>
        )}
      </div>
    </div>
  )
}

export default PwaModal